<template>
  <div class="footer">
    <br />
    <br />
    <div class="container">
      <div class="row">
        <div col="col-lg-8">
          <div class="row row1">
            <div
              v-for="(value, key) in cms.list"
              v-if="key < 3"
              class="icon-links"
            >
              <router-link
                :to="{ name: 'showPage', params: { type: value.pagetype } }"
              >
                <img class="link-item-img" :src="assetsSrc[key]" />
                <span>{{ value.title }}</span>
              </router-link>
            </div>
          </div>
          <div class="row row2">
            <div
              v-for="(value, key) in cms.list"
              v-if="key >= 3"
              class="icon-links"
            >
              <router-link
                :to="{ name: 'showPage', params: { type: value.pagetype } }"
              >
                <img class="link-item-img" :src="assetsSrc[key]" />
                {{ value.title }}
              </router-link>
            </div>
            <router-link class="icon-links" :to="{ name: 'contact' }">
              <img class="contact-link" :src="assetsSrc[5]" />Kontakt
            </router-link>
          </div>
        </div>
        <div v-if="user" class="col-lg-4 contact-panel">
          <br />
          <KeeperData />
          <SalesRep />
        </div>
      </div>
      <div class="row footer-copy">
        <div class="col-12">
          © 2019 P.P.H. Eskulap M. Furyk, J. Matłosz Sp.J. - Internetowa
          Platforma Handlowa
          <a href="//b2b.redbay.pl/">Redbay B2B</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Page } from "../RedbayComponents";
import KeeperData from "./../account/src/account/KeeperData.vue";
import SalesRep from "./../account/src/account/SalesRep.vue";

export default {
  components: {
    Page,
    KeeperData,
    SalesRep
  },
  data() {
    return {
      assetsSrc: [
        "https://b2b.eskulap.gliwice.pl/shops/13118/gfx/ico/lock.png",
        "https://b2b.eskulap.gliwice.pl/shops/13118/gfx/ico/rules.png",
        "https://b2b.eskulap.gliwice.pl/shops/13118/gfx/ico/buy.png",
        "https://b2b.eskulap.gliwice.pl/shops/13118/gfx/ico/platform.png",
        "https://b2b.eskulap.gliwice.pl/shops/13118/gfx/ico/program.png",
        "https://b2b.eskulap.gliwice.pl/shops/13118/gfx/ico/contact.png"
      ]
    };
  },
  computed: {
    ...mapState({
      cms: state => state.cms,
      user: state => state.user.authorizedUser
    })
  },
  beforeMount() {
    this.$store.dispatch("cms/getList");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/Footer.vue